import React, { useEffect } from 'react';

type Props = {
  data?: Record<string, number>;
  property: string;
  title: string;
  filter: string[];
  setFilter: React.Dispatch<React.SetStateAction<string[]>>;
};

const colors = [
  'bg-primary',
  'bg-secondary',
  'bg-accent',
  'bg-rose-600',
  'bg-violet-600',
  'bg-amber-600',
  'bg-emerald-600',
  'bg-cyan-600',
  'bg-lime-600',
  'bg-fuchsia-600',
  'bg-orange-600',
  'bg-teal-600',
  'bg-indigo-600',
  'bg-sky-600',
];
const ProgressBarWidget = (props: Props) => {
  const { data, property, filter, setFilter, title } = props;
  const sum = Object.values(data ?? {}).reduce((acc, val) => acc + val, 0);

  useEffect(() => {
    if (!data) return;

    const validatedFilter = filter.filter((item) => {
      const count = data[item];
      return count !== undefined && count > 0;
    });

    if (validatedFilter.length !== filter.length) {
      setFilter(validatedFilter);
    }
  }, [data, filter, setFilter]);

  const handleSelection = (value: string) => {
    const newFilter = toggleItem(filter, value);
    setFilter(newFilter);
  };

  function toggleItem(array: string[], item: string): string[] {
    if (array.includes(item)) {
      return array.filter((i) => i !== item); // remove if exists
    } else {
      return [...array, item]; // add if it does not exists
    }
  }

  if (!data) {
    return <div>No data to display</div>;
  }

  const sortedEntries = Object.entries(data).sort((a, b) => b[1] - a[1]);

  return (
    <div className="shadow-xl bg-base-00 rounded p-2 flex flex-col min-h-0 border border-base-300 flex-1 min-w-0">
      <div className="text-xl text-primary">{title}</div>
      <div className="flex w-full h-4 rounded-box overflow-hidden my-2 shadow-xl">
        {sortedEntries.map(([type, count], index) => {
          const percent = (count / sum) * 100;
          const color = colors[index % colors.length];
          return <div key={type} className={`${color}`} style={{ width: `${percent}%` }} />;
        })}
      </div>

      {/* Filter Options */}
      <div className="flex flex-col gap-1 overflow-y-auto flex-1 min-h-0">
        {data &&
          sortedEntries.map(([type, count], index) => (
            <div key={type} className="flex flex-row gap-2">
              <div className="flex flex-row gap-2 text-center items-center">
                <div className={`gap-2 w-4 h-4  ${colors[index % colors.length]}`}></div>
                <div
                  className={`${filter.includes(type) ? ' border-primary bg-primary rounded text-black' : ''}`}
                  onClick={() => handleSelection(type)}>
                  {type.length > 0 ? type : 'No Data'}: {count}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ProgressBarWidget;
